export default function getSearchParams(queryName = null) {
  const searchParams = new URLSearchParams(window.location.search);
  if (!queryName) {
    return searchParams;
  }
  return searchParams.get(queryName);
}
